import { render, staticRenderFns } from "./medsos_score_card.vue?vue&type=template&id=b4a724e2"
import script from "./medsos_score_card.vue?vue&type=script&lang=js"
export * from "./medsos_score_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports